var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9987 25.8333H12.4987C10.1728 25.8333 9.00979 25.8333 8.06346 26.1204C5.93279 26.7667 4.26543 28.4341 3.6191 30.5648C3.33203 31.5111 3.33203 32.6741 3.33203 35M24.1654 12.5C24.1654 16.6421 20.8075 20 16.6654 20C12.5232 20 9.16536 16.6421 9.16536 12.5C9.16536 8.35786 12.5232 5 16.6654 5C20.8075 5 24.1654 8.35786 24.1654 12.5ZM18.332 35L23.501 33.5232C23.7485 33.4524 23.8722 33.4171 23.9877 33.3641C24.0902 33.317 24.1876 33.2597 24.2785 33.1929C24.3809 33.1178 24.4719 33.0268 24.654 32.8447L35.4154 22.0834C36.5661 20.9328 36.5661 19.0672 35.4154 17.9166C34.2648 16.766 32.3993 16.7661 31.2487 17.9167L20.4873 28.6781C20.3053 28.8601 20.2143 28.9511 20.1391 29.0535C20.0724 29.1444 20.015 29.2419 19.9679 29.3444C19.9149 29.4598 19.8796 29.5836 19.8089 29.8311L18.332 35Z",
    stroke: "#38CB89",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserEdit);
export default __webpack_public_path__ + "static/media/user-edit.ce711b682b5dede02dacb166e7c50653.svg";
export { ForwardRef as ReactComponent };